import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import { Button } from '../ui/button';
import useAuthStore from '../../stores/authStore';

const PublicHeader = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <div className="flex items-center justify-center w-10 h-10">
              <img 
                src="/logo.svg" 
                alt="Think Robin Logo" 
                className="w-8 h-8 object-contain"
                onError={(e) => {
                  // Fallback to BarChart3 icon if image fails to load
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <BarChart3 
                className="w-6 h-6 text-primary-600" 
                style={{ display: 'none' }}
              />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">Think Robin</h1>
              <p className="text-xs text-gray-500">AI Powered Market Intelligence Platform</p>
            </div>
          </Link>
          
          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-gray-600 hover:text-gray-900 font-medium">
              Features
            </a>
            <a href="#pricing" className="text-gray-600 hover:text-gray-900 font-medium">
              Pricing
            </a>
          </nav>

          {/* Auth Button */}
          <div className="flex items-center">
            {isAuthenticated ? (
              <Button asChild>
                <Link to="/app">Dashboard</Link>
              </Button>
            ) : (
              <Button asChild>
                <Link to="/login">Sign In</Link>
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
